import { useQuery } from '@tanstack/react-query';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';
import type { Comparison, SearchComparisonsResponse } from '../../../types/BaselineMeasurements';
import type { AxiosResponse } from 'axios';

interface SearchComparisonsActiveQueryVariables {
  connectionId: Comparison['connectionId'];
}

const QUERY_KEY = 'searchComparisonsActive';

export const useSearchComparisonsActiveQuery = (variables: SearchComparisonsActiveQueryVariables) => {
  const { connectionId } = variables;
  return useQuery<SearchComparisonsResponse>({
    queryKey: [QUERY_KEY, connectionId],
    queryFn: async () => {
      const response = await baselineMeasurementService.searchActiveByConnectionId(connectionId);
      return (response as AxiosResponse).data;
    },
    enabled: !!connectionId,
  });
};
